"use client";
import { Tooltip } from "@material-tailwind/react";

const TooltipShipping = ({ tooltips }) => {
  return (
    <Tooltip
      className="z-50 bg-black text-white"
      content={
        <div className="max-w-md rounded-lg bg-black p-4">
          <p className="mt-2 text-white">
          Todos los pedidos realizados a través de nuestra página web desde el 20 de diciembre de 2024 hasta el 7 de enero de 2025 
          <span className="font-bold"> serán gestionados y tramitados para su envío en la segunda semana de enero de 2025. </span>
          Por este motivo, los tiempos de entrega podrán variar.
          </p>
          <p className="mt-4">
            ¡Gracias por tu comprensión y felices fiestas!
          </p>
        </div>
      }
    >
      <img
        src="/especificaciones/tooltipEspecificaciones.svg"
        alt="tooltips icon"
        style={{ width: "23px", height: "23px" }}
      />
    </Tooltip>
  );
};

export default TooltipShipping;